import type { SVGProps } from 'react'
const PenIconlyProIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 40 40" {...props}>
    <path
      fill="#2852E4"
      fillRule="evenodd"
      d="M15.943 20.666c-.626 0-1.125.514-1.125 1.125 0 .626.499 1.125 1.125 1.125.61 0 1.125-.499 1.125-1.125a1.14 1.14 0 0 0-1.125-1.125"
      clipRule="evenodd"
    />
    <path
      fill="#2852E4"
      fillRule="evenodd"
      d="M26.517 23.848c.803-.789.917-2.025.257-2.974l-4.357-6.068a.53.53 0 0 0-.587-.189 7 7 0 0 1-.44.119c-.305.063-.61.096-.915.111h-9.08a6 6 0 0 1-.916-.111 6 6 0 0 1-.426-.117.55.55 0 0 0-.613.188l-4.345 6.067c-.658.949-.53 2.202.29 2.974 1.784 1.703 6.204 6.09 8.565 10.3q.063.11.136.21c.23.313.65.096.65-.293v-8.599a.55.55 0 0 0-.322-.486 3.53 3.53 0 0 1-2.007-3.19 3.546 3.546 0 0 1 3.537-3.534 3.546 3.546 0 0 1 3.535 3.535 3.53 3.53 0 0 1-2.008 3.19.55.55 0 0 0-.322.485v8.56c0 .395.427.61.655.288q.062-.088.116-.183c2.49-4.402 7.199-8.982 8.597-10.283"
      clipRule="evenodd"
    />
    <g opacity={0.4}>
      <foreignObject width={39.386} height={31.037} x={-3.75} y={-6.518}>
        <div
          style={{
            backdropFilter: 'blur(5.64px)',
            clipPath: 'url(#Pen_-_Iconly_Pro_svg__a)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <path
        fill="url(#Pen_-_Iconly_Pro_svg__b)"
        fillRule="evenodd"
        d="M8.23 10.75a3.48 3.48 0 0 0 2.426 2.363c.288.081.595.13.9.13h8.773c.305 0 .612-.049.885-.13a3.42 3.42 0 0 0 2.425-2.362l.595-2.057a3 3 0 0 0-.498-2.7 3.02 3.02 0 0 0-2.459-1.236H10.591c-.964 0-1.864.45-2.442 1.236a3 3 0 0 0-.498 2.7z"
        clipRule="evenodd"
        data-figma-bg-blur-radius={11.276}
      />
      <foreignObject width={39.615} height={26.363} x={8.652} y={20.157}>
        <div
          style={{
            backdropFilter: 'blur(5.64px)',
            clipPath: 'url(#Pen_-_Iconly_Pro_svg__c)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <path
        fill="url(#Pen_-_Iconly_Pro_svg__d)"
        fillRule="evenodd"
        d="M35.741 32.744c-1.602 0-2.35-.27-3.218-.582-.949-.341-2.025-.73-4.067-.73-2.037 0-3.112.387-4.062.73-.866.312-1.613.582-3.216.582a1.25 1.25 0 0 0 0 2.5c2.038 0 3.115-.388 4.065-.73.866-.312 1.613-.582 3.213-.582 1.605 0 2.353.27 3.222.582.948.343 2.025.73 4.063.73a1.25 1.25 0 0 0 0-2.5"
        clipRule="evenodd"
        data-figma-bg-blur-radius={11.276}
      />
    </g>
    <defs>
      <linearGradient
        id="Pen_-_Iconly_Pro_svg__b"
        x1={9.327}
        x2={20.538}
        y1={5.54}
        y2={17.057}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <linearGradient
        id="Pen_-_Iconly_Pro_svg__d"
        x1={21.754}
        x2={25.419}
        y1={31.784}
        y2={40.279}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5A81FF" stopOpacity={0.9} />
        <stop offset={0.447} stopColor="#567DFF" stopOpacity={0.955} />
        <stop offset={1} stopColor="#4E78FF" stopOpacity={0.9} />
      </linearGradient>
      <clipPath id="Pen_-_Iconly_Pro_svg__a">
        <path
          fillRule="evenodd"
          d="M11.98 17.27a3.48 3.48 0 0 0 2.426 2.36c.289.082.595.13.9.13h8.774c.305 0 .611-.048.885-.13a3.42 3.42 0 0 0 2.425-2.36l.595-2.057a3 3 0 0 0-.499-2.7 3.02 3.02 0 0 0-2.458-1.237H14.34c-.963 0-1.863.45-2.441 1.237a3 3 0 0 0-.499 2.7z"
          clipRule="evenodd"
        />
      </clipPath>
      <clipPath id="Pen_-_Iconly_Pro_svg__c">
        <path
          fillRule="evenodd"
          d="M27.09 12.587c-1.602 0-2.35-.27-3.22-.581-.947-.342-2.024-.73-4.066-.73-2.036 0-3.111.386-4.061.73-.867.311-1.614.581-3.217.581a1.25 1.25 0 0 0 0 2.5c2.038 0 3.115-.388 4.065-.73.867-.311 1.613-.581 3.213-.581 1.605 0 2.354.27 3.222.582.948.343 2.025.73 4.063.73a1.25 1.25 0 0 0 0-2.5"
          clipRule="evenodd"
        />
      </clipPath>
    </defs>
  </svg>
)
export default PenIconlyProIcon
